export default [
  {
    id: "1",
    title: "Nivel de Azúcar 5 opciones",
    description:
      "Lorem ipsum dolor amet leggings microdosing man bun, YOLO normcore four loko authentic poke. Man braid wolf cornhole YOLO, cronut succulents chambray fashion axe. Whatever truffaut lomo distillery meditation marfa, shaman quinoa selvage retro la croix bushwick banh mi kitsch. Glossier blog chillwave vinyl vice. Etsy sustainable bespoke art party kitsch hashtag mlkshk cold-pressed kinfolk selfies. Tumblr deep v shabby chic, authentic gochujang pour-over selvage tofu next level street art pitchfork viral knausgaard polaroid. Everyday carry authentic truffaut marfa retro.",
    btns: {
      numFilas: 5,
      numColumnas: 2,
      items: [
        {
          cod_producto: 0,
          leyenda: "Sin azúcar",
          pos: {
            f: 1, //fila 1
            c: 1, //columna 1
          },
          img: {
            id: 1,
            name: "Sin azúcar",
            url: "/assets/dummy.png"
          }
        },
        {
          cod_producto: 1,
          leyenda: "Poca azúcar",
          pos: {
            f: 2, //fila
            c: 1, //columna
          },
          img: {
            id: 1,
            name: "Poca azúcar",
            url: "/assets/dummy.png"
          }
        },
        {
          cod_producto: 2,
          leyenda: "Con azúcar",
          pos: {
            f: 3, //fila
            c: 1, //columna
          },
          img: {
            id: 1,
            name: "Con azúcar",
            url: "/assets/dummy.png"
          }
        },
        {
          cod_producto: 3,
          leyenda: "Bastante azúcar",
          pos: {
            f: 1, //fila
            c: 2, //columna
          },
          img: {
            id: 1,
            name: "Bastante azúcar",
            url: "/assets/dummy.png"
          }
        },
        {
          cod_producto: 4,
          leyenda: "Mucha azúcar",
          pos: {
            f: 2, //fila
            c: 2, //columna
          },
          img: {
            id: 1,
            name: "Con mucha azúcar",
            url: "/assets/dummy.png"
          }
        },
        {
          cod_producto: 999,
          leyenda: "Volver a Productos",
          pos: {
            f: 3, //fila
            c: 2, //columna
          },
          img: {
            id: 1,
            name: "Volver a Productos",
            url: "/assets/dummy.png"
          }
        },
      ]
    },
  },
];
